/* eslint-disable no-duplicate-case */
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { tokenDecode } from "../../utils/helper";
import { useEffect, useState } from "react";

const ProtectedRoute = ({ children }: any) => {
  const navigate = useNavigate();
  const params = useParams();
  const token = params?.token;
  const location = useLocation();
  const tk_access = localStorage.getItem("us_st_d");
  const keyV = location.pathname.split("/")[1];
  const [shouldRender, setShouldRender] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    try {
      const decoded: any = tk_access ? tokenDecode(tk_access) : null;
      
      if (!decoded) {
        // Routes accessible without token
        const publicRoutes = [
          "forget-password", "reset-password", "adminDashboard", "sellerlist",
          "updateseller", "viewSeller", "sellerAllBookings", "updateServices",
          "createServices", "customerList", "viewCustomer", "updateCustomer", "bookingList",
          "registers", "contact-us", "free-listing", "contactSales", "contactCustomer",
          "test", "viewBooking", "Solutions", "resources", "features", "pricing", 
          "testclient", "Pricingplans", "previewpage", "EditAddress", "EditProfile",
          "BusinessRegistration", "Addservice", "products", "login", "book-demo",
          "solution-grooming", "solution-professional", "sol-veterinary-clinics",
          "Pricingpage", "solution-pet-boarding", "solution-pet-shop", "connectus",
          "free-trial", "vendor", "vendorregistration", "setpassword"
        ];

        if (publicRoutes.includes(keyV)) {
          setShouldRender(true);
        } else {
          navigate("/login");
        }
        setIsChecking(false);
        return;
      }

      // Check token expiration
      const expirationDate = new Date(decoded?.exp * 1000);
      const now = new Date();

      if (!expirationDate || expirationDate < now) {
        navigate("/");
        setIsChecking(false);
        return;
      }

      const roleType = decoded.data.user.role_type;

      // Handle vendor_free_listing role restrictions
      if (
        roleType === "vendor_free_listing" &&
        keyV !== "freelistinglanding" &&
        keyV !== "upgrade_plan" &&
        keyV !== "freelistCustomer"
      ) {
        navigate("/login");
        setIsChecking(false);
        return;
      }

      // Check if token param exists
      if (token && /^V\d+$/.test(token)) {
        setShouldRender(true);
        setIsChecking(false);
        return;
      }

      // Allowed routes for authenticated users
      const allowedRoutes = [
        "", "newcalender", "dashboard", "landing-page", "freelistCustomer",
        "previewpage", "upgrade_plan", "productlist", "ondcsellerproduct",
        "ondcsellerproductadd", "nonapprovedproducts", "nonapprovedproduct",
        "notifications", "sellernonapprovedproducts", "profile", "sellerdetail",
        "sidebar", "ondcsellerapp", "resetpassword", "selleregister",
        "personaldetails", "bankdetails", "checkseller", "pending", "brand",
        "sellerauthcheck", "newcategory", "seeorderdetails", "acceptedorderdetail",
        "orderpopup", "updatestoreproduct", "invoice", "invoices", "order_invoice",
        "updatepassword", "onlineRequest", "requestproductapproval", "update_booking",
        "calendar", "createAppointment", "edit_vendor_profile", "setup-guide",
        "chatwithcustomer", "client_pets", "view_client", "add_client", "clientchat",
        "add_pet", "all_bookings", "calendar_setting", "pet_photos", "overview",
        "document", "history", "add_client_2", "search_clients", "import-history",
        "admin", "viewBooking", "allbookings", "freelistinglanding", "adminLogin",
        "employees", "employee", "create_employee", "update_employee", "orderList",
        "invoiceList", "pos", "home", "client-details", "/calendar/availabilityCalendar", 
        "/orderList/addorder", "/client_pets/importData", "/client_pets/google-contacts",
        "/client_pets/import-excelData", "/client_pets/excelData-preview"
      ];

      // Additional calendar-related routes
      const calendarRoutes = [
        "newcalender/calendarOptions", "newcalender/appointmentType",
        "newcalender/appointmentServices", "newcalender/employeeOrder"
      ];

      if (allowedRoutes.includes(keyV) || calendarRoutes.includes(keyV)) {
        setShouldRender(true);
      } else {
        navigate("/login");
      }
      
    } catch (error) {
      // Routes accessible when error occurs
      const errorRoutes = [
        "forget-password", "contact-us", "free-listing", "reset-password",
        "sellerAllBookings", "adminDashboard", "sellerlist", "contactSales",
        "contactCustomer", "updateseller", "viewSeller", "test", "viewBooking",
        "updateServices", "createServices", "Solutions", "resources", "features",
        "customerList", "viewCustomer", "pricing", "testclient", "Pricingplans",
        "previewpage", "EditAddress", "EditProfile", "BusinessRegistration",
        "Addservice", "products", "login", "book-demo", "solution-grooming",
        "solution-professional", "sol-veterinary-clinics", "Pricingpage",
        "solution-pet-boarding", "solution-pet-shop", "connectus", "free-trial",
        "updateCustomer", "bookingList", "vendor", "vendorregistration", "setpassword"
      ];

      if (errorRoutes.includes(keyV)) {
        setShouldRender(true);
      } else {
        navigate("/login");
      }
    } finally {
      setIsChecking(false);
    }
  }, [navigate, tk_access, keyV, token, location]);

  // Show loading state while checking
  if (isChecking) {
    return React.createElement(
      "div",
      { style: { padding: 20, textAlign: "center" } },
      "Loading..."
    );
  }

  // Render children if allowed
  return shouldRender ? children : null;
};

export default ProtectedRoute;